import style from './pagination.module.css';

function Pagination({ currentPage, totalPages, onPageChange, pageNum }) {
    const pageNumbers = Array(totalPages).fill().map((_, index) => index + 1);
    let startPage = currentPage - 2;
    if (startPage < 1) {
        startPage = 1;
    }

    let endPage = startPage + 4;
    if (pageNum) {

        endPage = startPage + pageNum
    }
    if (endPage > totalPages) {
        endPage = totalPages;
        startPage = endPage - 4;
        if (startPage < 1) {
            startPage = 1;
        }
    }

    const handlerLeft = () => {
        if (currentPage === 1) return
        onPageChange(currentPage - 1)
    }

    const handlerRight = () => {
        if (currentPage === endPage) return
        onPageChange(currentPage + 1)
    }

    return (
        <div className={style.pagination}>
            <div
                className={style.pageNext}
                onPointerDown={handlerLeft}>
                &lt;
            </div>
            {pageNumbers.slice(startPage - 1, endPage).map((pageNumber) => (
                <div
                    key={pageNumber}
                    className={`${style.pageNumber}  ${pageNumber === currentPage ? style.activeBg : ''}`}
                    onPointerDown={() => onPageChange(pageNumber)}
                >
                    {pageNumber}
                </div>
            ))}
            <div
                className={style.pageNext}
                onPointerDown={handlerRight}>
                &gt;
            </div>
        </div>
    );
}

export default Pagination;
